<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingUnmatchedClientsList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="500"
            :footer-props="footerProps"
            class="product-table"
            dense
            :headers="tableHeaders"
            :items="unmatchedClients"
        >
            <template v-slot:item="{ item }">
                <tr
                    :key="'unmatched_client_' + item.id + '_' + item.source"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow: activeUnmatchedClient &&
                            parseInt(item.id) === parseInt(activeUnmatchedClient.id) &&
                            item.source === activeUnmatchedClient.source
                    }"
                >
                    <td>{{ item.code || "-" }}</td>
                    <td style="text-align: left;">{{ item.name || "-" }}</td>
                    <td style="text-align: left;">
                        {{ formatType(item.type) }}
                    </td>
                    <td style="text-align: left;">{{ item.source === 'invoice' ? 'Odoo' : 'Import' }}</td>
                    <td style="text-align: end;">{{ item.date || "-" }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import Store from "../../store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "unmatched-clients-list",
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            tableHeaders: [
                {
                    text: this.t("Code"),
                    align: "left",
                    value: "code"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Type"),
                    align: "left",
                    value: "type"
                },
                {
                    text: this.t("Source"),
                    align: "left",
                    value: "source"
                },
                {
                    text: this.t("Date"),
                    align: "end",
                    value: "date"
                }
            ]
        };
    },
    mounted() {
        Store.dispatch("UnmatchedShopsStore/getUnmatchedClientsList");
    },
    computed: {
        ...mapState("UnmatchedShopsStore", [
            "unmatchedClients",
            "loadingUnmatchedClientsList",
            "activeUnmatchedClient",
            "clients"
        ]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapMutations("UnmatchedShopsStore", ["setActiveUnmatchedClient"]),
        formatType(type) {
            if (!type) return "-";
            return (type.charAt(0).toUpperCase() + type.slice(1)).replaceAll("_", " ");
        },
        handleTableRowClick(item) {
            this.setActiveUnmatchedClient(item);
            this.$router.push({
                name: "unmatched-client-view",
                params: { recordId: item.id, source: item.source }
            });
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

td {
    padding: 0px;
    height: 25px !important;
}

::v-deep .v-data-table-header th {
    white-space: nowrap;
}
</style>
